export const customStyles = {
  control: (styles, state) => ({
    ...styles,
    width: "100%",
    maxWidth: "20rem",
    minWidth: "8rem",
    borderRadius: "2px",
    color: "#cccccc",
    fontSize: "0.75rem",
    lineHeight: "1.75rem",
    backgroundColor: "#3c3c3c",
    cursor: "pointer",
    border: state.isFocused ? "1px solid #0078d4" : "1px solid #3c3c3c",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #0078d4",
    },
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#cccccc",
  }),
  input: (styles) => ({
    ...styles,
    color: "#cccccc",
  }),
  option: (styles, state) => ({
    ...styles,
    color: state.isSelected ? "#ffffff" : "#cccccc",
    fontSize: "0.75rem",
    lineHeight: "1.75rem",
    width: "100%",
    backgroundColor: state.isSelected
      ? "#04395e"
      : state.isFocused
      ? "#2a2d2e"
      : "#252526",
    cursor: "pointer",
  }),
  menu: (styles) => ({
    ...styles,
    backgroundColor: "#252526",
    maxWidth: "16rem",
    border: "1px solid #454545",
    borderRadius: "2px",
    zIndex: 30,
  }),
  menuList: (styles) => ({
    ...styles,
    padding: 0,
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#858585",
    fontSize: "0.75rem",
    lineHeight: "1.75rem",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    backgroundColor: "#454545",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: "#858585",
    "&:hover": { color: "#cccccc" },
  }),
};
